<template>
  <aside
    class="absolute z-50 top-0 right-0 sm:relative sm:h-full sm:min-h-screen bg-slate-800 flex flex-col items-center transition-all overflow-hidden" :class="isOpen ? 'w-64 h-full' : 'w-16 h-16'"
    ref="sideBar">
    <div class="w-full flex justify-between py-5 px-5 sm:mr-1 min-h-[80px]">
      <div @click="isOpen = !isOpen" class="cursor-pointer">
        <font-awesome-icon icon="fa-solid fa-xmark" v-if="isOpen" class="text-white text-2xl" />
        <font-awesome-icon icon="fa-solid fa-bars" v-else class="text-white text-2xl" />
      </div>
      <div v-if="isOpen" @click="toggleDarkMode" class="cursor-pointer rounded-full bg-slate-50 dark:bg-yellow-50 transition-all flex items-center justify-center w-10 h-10 text-slate-600" :class="isOpen?'opacity-100':'opacity-0'">
        <font-awesome-icon v-if="darkMode" icon="fa-solid fa-sun" class="text-lg "/>
        <font-awesome-icon v-else icon="fa-solid fa-moon" class="text-lg "/>
      </div>
    </div>
    <div class="relative">
      <div class="shadow-inner bg-white flex items-center justify-center rounded-full w-44 h-44 overflow-hidden mb-10 transition-all" :class="isOpen?'opacity-100':'opacity-0'">
        <img class="object-contain h-36" src="@/assets/images/logo.png" alt="logo">
      </div>
      <p class="absolute top-1/2 left-1/2 whitespace-nowrap text-white font-bold text-center text-lg write-vertical transform -translate-x-1/2 -translate-y-1/2 delay-75" :class="isOpen?'opacity-0':'opacity-100'">مجتمع آموزشی معلم</p>
    </div>
    <div class="flex flex-col w-full p-3">
      <slot></slot>
    </div>
  </aside>
</template>

<script setup>
import store from '@/store';
import { inject, ref, watch, computed} from 'vue';
import { useRoute } from 'vue-router';

const sideBar = ref(null);
const isOpen = inject("status");
const route = useRoute();

watch(()=>route.fullPath,()=>{
  isOpen.value = false;
})

const darkMode = computed(()=>{
  return store.getters.getDarkMode;
});

//methods
function toggleDarkMode(){
  let darkmode = true;
  if(darkMode.value){
    darkmode = false;
  }

  store.dispatch("setDarkModeToLocaleStorage",darkmode);
}

</script>